<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="lot-tab">
	<div class="table-responsive" *ngIf="auditChanges">
		<table class="table table-striped table-bordered table-curved table-fixed" *ngIf="auditChanges.length else nodata">
			<thead>
			<tr>
				<th scope="col" jhiTranslate="audit.germplasm-progenitors.progenitor">Progenitor</th>
				<th scope="col" jhiTranslate="audit.germplasm-progenitors.progenitor-number">Progenitor Number</th>
				<th scope="col" jhiTranslate="audit.event-type">Event Type</th>
				<th scope="col" class="fixed-collapse-horizontal-100">
					<span jhiTranslate="audit.event-date">Timestamp</span>
					<span class="fa fa-sort fa-sort-down"></span>
				</th>
				<th scope="col" jhiTranslate="audit.user">User</th>
			</tr>
			</thead>
			<tbody>
			<tr *ngFor="let change of auditChanges">
				<td>
					<a [href]="this.germplasmDetailsUrlService.getUrl(change.progenitorGid)" target="_blank">GID{{change.progenitorGid}}</a>
				</td>
				<td>{{change.progenitorsNumber}}</td>
				<td>{{change.revisionType}}</td>
				<td>{{getEventDate(change)}}</td>
				<td>{{getEventUser(change)}}</td>
			</tr>
			</tbody>
		</table>
		<ng-template #nodata>
			<table class="table table-striped table-bordered table-curved">
				<thead>
				<tr>
					<th></th>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td jhiTranslate="no.data"></td>
				</tr>
				</tbody>
			</table>
		</ng-template>
		<div *ngIf="auditChanges && auditChanges.length">
			<div class="row">
				<div class="col">
					<div class="pagination-container">
						<div class="pagination-box pagination-box-left">
							<div>
								<jhi-item-count [page]="page" [total]="queryCount" [itemsPerPage]="itemsPerPage"></jhi-item-count>
							</div>
						</div>
						<div class="pagination-box">
							<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
											[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
						</div>
						<div class="pagination-box pagination-box-right">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
